// Verificar si los logs están deshabilitados mediante variable de entorno
const LOGS_ENABLED = import.meta.env.VITE_ENABLE_LOGS !== 'false';

const LOG_STYLES = {
    system: {
        prefix: '⚙️',
        color: '#4CAF50',
        background: '#E8F5E9',
        label: 'System'
    },
    auth: {
        prefix: '🔐',
        color: '#2196F3',
        background: '#E3F2FD',
        label: 'Auth'
    },
    profile: {
        prefix: '👤',
        color: '#9C27B0',
        background: '#F3E5F5',
        label: 'Profile'
    },
    billing: {
        prefix: '💰',
        color: '#FF9800',
        background: '#FFF3E0',
        label: 'Billing'
    },
    error: {
        prefix: '❌',
        color: '#F44336',
        background: '#FFEBEE',
        label: 'Error'
    },
    user: {
        prefix: '👥',
        color: '#3F51B5',
        background: '#E8EAF6',
        label: 'User'
    },
    globalEvent: {
        prefix: '🌐',
        color: '#009688',
        background: '#E0F2F1',
        label: 'GlobalEvent'
    },
    warn: {
        prefix: '⚠️',
        color: '#FF9800',
        background: '#FFF3E0',
        label: 'Warning'
    }
};

// Funciones helper para reemplazar console.log, console.error, etc.
// Estas funciones respetan la variable de entorno VITE_ENABLE_LOGS
export const log = (...args) => {
    if (LOGS_ENABLED) {
        console.log(...args);
    }
};

export const logError = (...args) => {
    if (LOGS_ENABLED) {
        console.error(...args);
    }
};

export const logWarn = (...args) => {
    if (LOGS_ENABLED) {
        console.warn(...args);
    }
};

export const logDebug = (...args) => {
    if (LOGS_ENABLED) {
        console.debug(...args);
    }
};

class Logger {
    static _formatMessage(type, message, data = null) {
        // Si los logs están deshabilitados, no hacer nada
        if (!LOGS_ENABLED) {
            return;
        }

        const style = LOG_STYLES[type] || LOG_STYLES.system;
        const timestamp = new Date().toISOString().split('T')[1].split('.')[0];
        
        const baseStyle = `
            color: ${style.color};
            background: ${style.background};
            padding: 2px 5px;
            border-radius: 3px;
            font-weight: bold;
        `;

        const prefix = `${style.prefix} [${style.label}]`;
        
        if (data) {
            console.groupCollapsed(`%c${prefix} ${message}`, baseStyle);
            console.log(`⏰ Timestamp: ${timestamp}`);
            console.log('📦 Data:', data);
            console.groupEnd();
        } else {
            console.log(`%c${prefix} ${message}`, baseStyle);
        }
    }

    static init(message, data = null) {
        this._formatMessage('system', message, data);
    }

    static auth(message, data = null) {
        this._formatMessage('auth', message, data);
    }

    static profile(message, data = null) {
        this._formatMessage('profile', message, data);
    }

    static billing(message, data = null) {
        this._formatMessage('billing', message, data);
    }

    static error(message, data = null) {
        this._formatMessage('error', message, data);
    }

    static user(message, data = null) {
        this._formatMessage('user', message, data);
    }

    static system(message, data = null) {
        this._formatMessage('system', message, data);
    }

    static info(message, data = null) {
        this._formatMessage('system', message, data);
    }

    static globalEvent(message, data = null) {
        this._formatMessage('globalEvent', message, data);
    }

    static warn(message, data = null) {
        this._formatMessage('warn', message, data);
    }
}

export default Logger;
